import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class EmeProductTitle extends Component {
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  #handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    try {
      const { detail } = await event.promise;
      const next = detail?.html?.querySelector(
        `eme-product-title[data-block-id="${this.dataset.blockId}"] [ref="heading"]`
      );
      if (next && this.refs.heading) this.refs.heading.textContent = next.textContent;
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[eme-product-title] Event promise rejected:', error);
    }
  };
}

if (!customElements.get('eme-product-title')) {
  customElements.define('eme-product-title', EmeProductTitle);
}
